import { ParticipantModel } from "models/ParticipantModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

export interface ParticipantsContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: ParticipantModel) => void;
}

export const ParticipantsContextMenuContext = createContext({} as ParticipantsContextMenuContextProps);
